module.exports = __webpack_public_path__ + "img/student_32.094552e4.png";